import React, { useState } from 'react';
import CheveronIcon from '@/assets/icon-cheveron.svg?react';
import { extractFilters } from '@/services/aiApps';

type Filters = Record<string, string | number | boolean>;

const ContextFeild = ({ sqlSections }) => {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState<Filters>({});
  const handleContextFeildClick = async () => {
    if (!open) {
      setOpen(true);
    } else {
      setOpen(false);
    }

    let finalSQL;
    sqlSections.map((section) => {
      if (section.final.length > 0) {
        finalSQL = section?.final[section?.final?.length - 1]?.code;
      }
    });

    try {
      const reqBody = {
        dialect: 'tsql',
        sql_query: finalSQL || '',
      };
      const response = await extractFilters(reqBody);
      setFilters(response?.filters);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="sys-msg-sources mt-3">
        <div>
          <div className=" sys-msg-sources-label" onClick={handleContextFeildClick}>
            <p className="context-feild">
              Context Fields <CheveronIcon className={`${open ? '' : 'accordian-cheveron'}`} />
            </p>
          </div>
          {open && filters && Object.keys(filters).length > 0 && (
            <div className="info-card">
              {filters &&
                Object.entries(filters).map(([key, value]) => (
                  <p key={key}>
                    <span className="label">{key}</span>
                    <span className="separator"> : </span>
                    <span className="value">{value}</span>
                  </p>
                ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContextFeild;
